import { connect } from 'react-redux'
import { IStoreState } from '../../types/index'
import * as actions from '../../state/actions/global-settings'
import ServiceLevelPane from 'src/components/global-settings/ServiceLevelPane'

const mapStateToProps = (state: IStoreState, ownProps: any): any => {
  return {
    serviceLevels: state.globalSettings.serviceLevels.items
  }
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    fetchServiceLevels: () => dispatch(actions.fetchServiceLevels()),
    createServiceLevel: (payload: { name: string }) => dispatch(actions.createServiceLevel(payload))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceLevelPane)



// WEBPACK FOOTER //
// ./src/containers/global-settings/ServiceLevelPane.ts